<template>
  <div>
    <div :id="elId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import china from '@/json/china.json'
echarts.registerMap('china', china)

export default {
  props: {
    elId: String,
    width: { type: String, default: '100%' },
    height: { type: String, default: '100%' },
    option: { type: Object, default: () => ({}) }
  },
  created() {
    this.$nextTick(() => {
      this.init()
    })
  },
  mounted() {
    let _this = this
    window.onresize = function () {
      _this.chart.resize()
    }
  },
  data() {
    return {
      chart: null,
      defaultOpt: {
        grid: {
          left: '60',
          top: '50',
          right: '30',
          bottom: '50'
        }
      }
    }
  },
  watch: {
    option: {
      handler(newVal, oldVal) {
        if (this.chart) {
          if (newVal) {
            this.chart.clear()
            this.chart.setOption({
              ...this.defaultOpt,
              ...this.option
            })
          }
        } else {
          this.init()
        }
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.chart = echarts.init(document.getElementById(this.elId))
      this.chart.setOption({
        ...this.defaultOpt,
        ...this.option
      })
    }
  },
  name: 'echarts'
}
</script>

<style scoped>
</style>
